import { render } from "./FoodSlider.vue?vue&type=template&id=19406079"
import script from "./FoodSlider.vue?vue&type=script&lang=js"
export * from "./FoodSlider.vue?vue&type=script&lang=js"

import "./FoodSlider.vue?vue&type=style&index=0&id=19406079&lang=scss"
import "./FoodSlider.vue?vue&type=style&index=1&id=19406079&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__